import { render, staticRenderFns } from "./ProfileSetting.vue?vue&type=template&id=8afffa82&scoped=true"
import script from "./ProfileSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSetting.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSetting.vue?vue&type=style&index=0&id=8afffa82&prod&lang=scss"
import style1 from "./ProfileSetting.vue?vue&type=style&index=1&id=8afffa82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afffa82",
  null
  
)

export default component.exports